var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "384.277px",
    height: "249.057px",
    viewBox: "0 0 384.277 249.057",
    enableBackground: "new 0 0 384.277 249.057",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3A495D",
    d: "M375.977,4.506H9.65c-3.132,0-5.67,2.538-5.67,5.669v200.331h377.667V10.175 C381.647,7.044,379.11,4.506,375.977,4.506z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.98,
    y: 15.839,
    fill: "#53B1E4",
    width: 353.667,
    height: 183.667
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E4DB",
    d: "M3.98,240.837c0,3.131,2.538,5.669,5.67,5.669h366.327c3.133,0,5.67-2.538,5.67-5.669v-30.331H3.98V240.837 z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E0DDD8",
    cx: 192.814,
    cy: 230.341,
    r: 5.833
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompHead);
export default __webpack_public_path__ + "static/media/comp_head.cfc2a9527c8d97739838bafbd15c7136.svg";
export { ForwardRef as ReactComponent };